import moment from "moment";
export const formatarTelefone = (telefone) => {
    if (telefone === null || typeof telefone == "undefined" || Object.keys(telefone).length === 0) {
        return "";
    }
    if (Object.keys(telefone).length === 11) {
        return telefone.replace(/\D/g, '').replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2').replace(/(-\d{4})\d+?$/, '$1');
    }
    return telefone.replace(/\D/g, '').replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d)/, '$1-$2').replace(/(-\d{4})\d+?$/, '$1');
};

export const formatarCEP = (cep) => {
    if (cep === null || Object.keys(cep).length === 0) {
        return "";
    }
    if (Object.keys(cep).length <= 5) {
        return cep.replace(/\D/g, '').replace(/(\d{5})(\d)/, '$1-$2') + "000"
    }
    return cep.replace(/\D/g, '').replace(/(\d{5})(\d)/, '$1-$2').replace(/(-\d{3})\d+?$/, '$1')
};

export const formatarDataHora = (data, tamanhoHorario = 8) => {
    if (data === null || Object.keys(data).length === 0 || typeof data == "undefined") {
        return "";
    }
    if (Object.keys(data).length >= 16 && tamanhoHorario == 4) {
        return data.substr(8,2) + '/' + data.substr(5,2) + '/' + data.substr(0,4) + ' '  +  data.substr(11,5);
    }
    if (Object.keys(data).length >= 16 && tamanhoHorario == 0) {
        return data.substr(8,2) + '/' + data.substr(5,2) + '/' + data.substr(0,4);
    }
    if (Object.keys(data).length >= 16 && tamanhoHorario == 6) {
        return data.substr(8,2) + '/' + data.substr(5,2) + '/' + data.substr(0,4) + ' '  +  data.substr(11,8);
    }
    if (Object.keys(data).length >= 16 && tamanhoHorario == 8) {
        return data.substr(8,2) + '/' + data.substr(5,2) + '/' + data.substr(0,4) + ' '  +  data.substr(11,8);
    }    
    return "";
};

export const convertDateTimeFinalDia = (_data) => {
let _dataFinalDia = moment(_data.setSeconds(86399) + (_data.getTimezoneOffset() * 60000));
    _dataFinalDia = new Date(_dataFinalDia + (3600000 * -3));  // FUSO HORÁRIO MUDA HORA PARA 23:59:59
    return _dataFinalDia;
}

export const pegarDateTimeAtualRetornaString = (_maisMinutos = 0) => {
    let currentdate = new Date(); 
    let _ajustado = currentdate.getFullYear() + "-" + currentdate.getMonth() + "-" + currentdate.getDate() + " " + currentdate.getHours() + ":" + currentdate.getMinutes() + ":" + currentdate.getSeconds(); 
    return moment(_ajustado);
}

export const numberWithCommas = (x) => {
    if (x == null){
        return "0,00";
    }
    return x.toLocaleString('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

window.objectLength = function (obj) {
    var result = 0;
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            // or Object.prototype.hasOwnProperty.call(obj, prop)
            result++;
        }
    }
    return result;
};

window.setCookie = function (name, value, days) {
    //export function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

window.getCookie = function (name) {
    //export function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

window.isRealObject = function (obj) {
    return obj && obj !== 'null' && obj !== 'undefined' && obj.length > 0;
};

window.atualizarCookieCarrinho = function (codigo, quantidade, itemQuantidade) {
    if (!codigo) {
        return;
    }
    if (quantidade == 0) {

    }
    let newItem = { codigo: codigo, quantidade: quantidade };
    let cart = window.getCookie("nafil_carrinho");
    if (cart === null) {
        window.setCookie("nafil_carrinho", "", 31);
    }
    cart = window.getCookie("nafil_carrinho");
    let cookieData = [];
    let obj;

    if (cart != "") {
        obj = JSON.parse(cart).find(o => o.codigo == codigo);
    }

    if (typeof (obj) === 'undefined') {
        // Se o Item Clicado Ainda Não Estiver no Carrinho              
        if (cart === "") {
            cookieData.push(newItem);
            cookieData = JSON.stringify(cookieData);
            itemQuantidade = 1;
            ///setItemQuantidade(1);
        }
        else {
            cookieData = JSON.parse(cart);
            cookieData.push(newItem);
            cookieData = JSON.stringify(cookieData);
            itemQuantidade = 1;
            //setItemQuantidade(1);
        }
        window.setCookie("nafil_carrinho", cookieData, 31);
        // setCarrinhoCounter(JSON.parse(cookieData).length);
    }
    else {
        // Se o Item Clicado Já Estiver no Carrinho   
        obj.quantidade += newItem.quantidade;
        let index = JSON.parse(cart).findIndex(o => o.codigo == codigo);
        if (index != -1) {
            cookieData = JSON.parse(cart);
            cookieData[index].quantidade = obj.quantidade;
        }
        cookieData = JSON.stringify(cookieData);
        window.setCookie("nafil_carrinho", cookieData, 31);
        itemQuantidade = obj.quantidade;
        //setItemQuantidade(obj.quantidade);
    }
};

export function eraseCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export function identificacaoUsuarioLogado(){
    if (sessionStorage.getItem("id_loja_usuario") == null || sessionStorage.getItem("id_loja_usuario") == ""){
       return "";        
    }
    return (Buffer.from( sessionStorage.getItem("id_loja_usuario").replace('YfhR7sFdS53a==','').substring(2) , 'base64').toString());
}

export function identificacaoRazaoSocialUsuarioLogado(){
    if (sessionStorage.getItem("nome_razao_social_logado") == null || sessionStorage.getItem("nome_razao_social_logado") == ""){
        return "";        
    }
    return (Buffer.from( sessionStorage.getItem("nome_razao_social_logado").replaceAll('!','=').replace('POsr34qa2esTraAb==','').substring(5) , 'base64').toString());
}

export function identificacaoNomeUsuarioLogado(){
    if (sessionStorage.getItem("nome_usuario_logado") == null || sessionStorage.getItem("nome_usuario_logado") == ""){
        return "";        
    }
    return (Buffer.from( sessionStorage.getItem("nome_usuario_logado").replaceAll('!','=').replace('XwQq43s741wOpUUsVbqa==','').substring(7) , 'base64').toString());
}

export function identificaoEnderecoEntrega(){
    if (window.getCookie("nafil_endereco_entrega") == null || window.getCookie("nafil_endereco_entrega") == ""){    
        return "";        
    }
    return (Buffer.from( window.getCookie("nafil_endereco_entrega").substring(7) , 'base64').toString());
}

export function identificaTipoOperacaoContasFaturadas(_especie){
    if (_especie == null || _especie <= 0){    
        return "DESCONHECIDA";        
    }
    else if (_especie == 1){    
        return "VENDA";        
    }
    else if (_especie == 2){    
        return "DEVOLUÇÃO";        
    }
    else if (_especie == 3){    
        return "CRÉDITO";        
    }
    else if (_especie == 9){    
        return "";  // SUB-TOTAL DA NOTA       
    }
}

export function create_UUID(){
    // Get the current time in milliseconds since the Unix epoch.
    var dt = new Date().getTime();
    // Replace the placeholders in the UUID template with random hexadecimal characters.
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // Generate a random hexadecimal digit.
        var r = (dt + Math.random()*16)%16 | 0;
        // Update dt to simulate passage of time for the next random character.
        dt = Math.floor(dt/16);
        // Replace 'x' with a random digit and 'y' with a specific digit (4 for UUID version 4).
        return (c=='x' ? r :(r&0x3|0x8)).toString(16);
    });
    // Return the generated UUID.
    return uuid;
}

export function aceitaApenasNumeros(textoDigitado){
    var numberPattern = /\d+/g;
    var _retornoNumero = textoDigitado.match( numberPattern );
    return _retornoNumero;    
}

export function aceitaApenasDatas(textoDigitado){
    if (textoDigitado.length != 10){
        return false; 
    }
    if (!Date.parse(textoDigitado)){ 
        return false; 
     } else { 
       return true; 
     } 
}

export function validaCpfCnpj(val) {
    if (val == null) return false;
    val = val.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "");

    if (val == "00000000000") return false;
    if (val == "00000000000000") return false;
    if (val == "99999999999") return false;
    if (val == "99999999999999") return false;

    if (val.length == 11) {
        var cpf = val.trim();

        cpf = cpf.replace(/\./g, '');
        cpf = cpf.replace('-', '');
        cpf = cpf.split('');

        var v1 = 0;
        var v2 = 0;
        var aux = false;

        for (var i = 1; cpf.length > i; i++) {
            if (cpf[i - 1] != cpf[i]) {
                aux = true;
            }
        }

        if (aux == false) {
            return false;
        }

        for (var i = 0, p = 10; (cpf.length - 2) > i; i++, p--) {
            v1 += cpf[i] * p;
        }

        v1 = ((v1 * 10) % 11);

        if (v1 == 10) {
            v1 = 0;
        }

        if (v1 != cpf[9]) {
            return false;
        }

        for (var i = 0, p = 11; (cpf.length - 1) > i; i++, p--) {
            v2 += cpf[i] * p;
        }

        v2 = ((v2 * 10) % 11);

        if (v2 == 10) {
            v2 = 0;
        }

        if (v2 != cpf[10]) {
            return false;
        } else {
            return true;
        }
    } else if (val.length == 14) {
        var cnpj = val.trim();

        cnpj = cnpj.replace(/\./g, '');
        cnpj = cnpj.replace('-', '');
        cnpj = cnpj.replace('/', '');
        cnpj = cnpj.split('');

        var v1 = 0;
        var v2 = 0;
        var aux = false;

        for (var i = 1; cnpj.length > i; i++) {
            if (cnpj[i - 1] != cnpj[i]) {
                aux = true;
            }
        }

        if (aux == false) {
            return false;
        }

        for (var i = 0, p1 = 5, p2 = 13; (cnpj.length - 2) > i; i++, p1--, p2--) {
            if (p1 >= 2) {
                v1 += cnpj[i] * p1;
            } else {
                v1 += cnpj[i] * p2;
            }
        }

        v1 = (v1 % 11);

        if (v1 < 2) {
            v1 = 0;
        } else {
            v1 = (11 - v1);
        }

        if (v1 != cnpj[12]) {
            return false;
        }

        for (var i = 0, p1 = 6, p2 = 14; (cnpj.length - 1) > i; i++, p1--, p2--) {
            if (p1 >= 2) {
                v2 += cnpj[i] * p1;
            } else {
                v2 += cnpj[i] * p2;
            }
        }

        v2 = (v2 % 11);

        if (v2 < 2) {
            v2 = 0;
        } else {
            v2 = (11 - v2);
        }

        if (v2 != cnpj[13]) {
            return false;
        } else {
            return true;
        }
    } else {
        return false;
    }
}

export function CartaoCreditoTipo(cardNumber) {
    let amex = new RegExp('^3[47][0-9]{13}$');
    let visa = new RegExp('^4[0-9]{12}(?:[0-9]{3})?$');
    // let elo = new RegExp('/^4011(78|79)|^43(1274|8935)|^45(1416|7393|763(1|2))|^50(4175|6699|67[0-6][0-9]|677[0-8]|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9])');
    let elo = new RegExp('^(4011(78|79)|43(1274|8935)|45(1416|7393|763(1|2))|50(4175|6699|67[0-7][0-9]|9000)|50(9[0-9][0-9][0-9])|627780|63(6297|6368)|650(03([^4])|04([0-9])|05(0|1)|05([7-9])|06([0-9])|07([0-9])|08([0-9])|4([0-3][0-9]|8[5-9]|9[0-9])|5([0-9][0-9]|3[0-8])|9([0-6][0-9]|7[0-8])|7([0-2][0-9])|541|700|720|727|901)|65165([2-9])|6516([6-7][0-9])|65500([0-9])|6550([0-5][0-9])|655021|65505([6-7])|6516([8-9][0-9])|65170([0-4]))');
    let cup1 = new RegExp('^62[0-9]{14}[0-9]*$');
    let cup2 = new RegExp('^81[0-9]{14}[0-9]*$');
  
    let mastercard = new RegExp('^5[1-5][0-9]{14}$');
    let mastercard2 = new RegExp('^2[2-7][0-9]{14}$');
  
    let disco1 = new RegExp('^6011[0-9]{12}[0-9]*$');
    let disco2 = new RegExp('^62[24568][0-9]{13}[0-9]*$');
    let disco3 = new RegExp('^6[45][0-9]{14}[0-9]*$');
    
    let diners = new RegExp('^3[0689][0-9]{12}[0-9]*$');
    let hipercard = new RegExp('^606282|^3841(?:[0|4|6]{1})0');
    let hiper = new RegExp('^637095|63737423|63743358|637568|637599|637609|637612[0-9]{14}[0-9]*$');
    let cabal = new RegExp('^(60420[1-9]|6042[1-9][0-9]|6043[0-9]{2}|604400)');

    let jcb =  new RegExp('^35[0-9]{14}[0-9]*$');
  
    if (elo.test(cardNumber)) {
        return 'ELO';
    }    
    if (hipercard.test(cardNumber)) {
        return 'HIPERCARD';
    }
    if (hiper.test(cardNumber)) {
        return 'HIPER';
    }
    if (cabal.test(cardNumber)) {
        return 'CABAL';
    }
    if (visa.test(cardNumber)) {
      return 'VISA';
    }
    if (amex.test(cardNumber)) {
      return 'AMEX';
    }
    if (mastercard.test(cardNumber) || mastercard2.test(cardNumber)) {
      return 'MASTERCARD';
    }
    if (disco1.test(cardNumber) || disco2.test(cardNumber) || disco3.test(cardNumber)) {
      return 'DISCOVER';
    }
    if (diners.test(cardNumber)) {
      return 'DINERS';
    }
    if (jcb.test(cardNumber)) {
      return 'JCB';
    }
    if (cup1.test(cardNumber) || cup2.test(cardNumber)) {
      return 'CHINA_UNION_PAY';
    }
    return undefined;
  }

  export const tipoDeNotaFaturada = (especie) => {
    if (especie === null) {
        return "";
    }
    if (especie == 1) {
        return "VENDA";
    }
    if (especie == 2) {
        return "DEVOLUÇÃO";
    }
    if (especie == 3) {
        return "CRÉDITO";
    }
    return "";
};







